import loadExternalScript from './loadExternalScript';

export default ({
  page: { productType },
  returnsSettings: {
    [productType]: { returnOptions: { enabled: returnOptionsEnabled = false } = {} } = {},
  } = {},
}) => {
  if (returnOptionsEnabled) {
    loadExternalScript({
      url: `${window.NARVARJS_URL}/narvartemplate/returnlocations.js`,
    });
  }
};
